module.exports = __webpack_public_path__ + "static/img/surrey_wheels.6189af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/surrey_wheels.png
// module id = QN7C
// module chunks = 1